import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

import {REGION} from "../../shared/defines/gukeo.const";
import {GetRegionCss} from 'src/app/shared/defines/desktop.const';
import {Dialect} from "../../shared/models/dialect.model";
import {DialectService} from "../../shared/services/dialect/dialect.service";

@Component({
  selector: 'app-dialect-item-body',
  templateUrl: './dialect-item-body.component.html',
  styleUrls: ['./dialect-item-body.component.scss']
})
export class DialectItemBodyComponent implements OnInit {
  @HostBinding('class') class = 'word-item-body-box';
  @HostBinding('style.display') styleBlock = 'block';
  @Input() dialect_id: string | null = null;
  @Output() loadComplete: EventEmitter<Dialect> = new EventEmitter<Dialect>();

  protected dialect: Dialect | null = null;

  constructor(
    private dialectSvc: DialectService,
  ) {
  }

  ngOnInit() {
    if (this.dialect_id === null) {
      throw new Error('DialectItemBodyComponent::ngOnInit() id is null');
    }
    this.dialectSvc.GetDetail(this.dialect_id)
      .subscribe(dialect => {
        console.log('DialectDetailComponent::dialectSvc.GetDetail() =', dialect);
        this.dialect = dialect;
        this.loadComplete.emit(dialect);
        }, err => console.error(err)
      );
  }


  protected GetRegionCss(region: REGION | null): string {
    return region === null ? '' : GetRegionCss(region) || '';
  }

}
